import { axiosChartInstance } from "config";
import { useAxiosMutation } from "hooks";
import { useQueryClient } from "react-query";

function useExportableSharedChartNote(noteId: string, isSubsection: boolean) {
  const queryClient = useQueryClient();

  return useAxiosMutation(
    ["exportableSharedChartNote", { noteId }],
    (isExportable: boolean) => {
      if (isSubsection) {
        return axiosChartInstance.put(
          `v1/ChartNote/update-exportable/${noteId}/${isExportable}`
        );
      }
      return axiosChartInstance.put(
        `v1/ChartNote/update-exportable/${noteId}/${isExportable}`
      );
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["sharedChartNotes"]);
        queryClient.invalidateQueries(["sectionNotesCount"]);
        queryClient.invalidateQueries(["subSectionNotesCount"]);
      },
    }
  );
}

export { useExportableSharedChartNote };
